module.exports = __webpack_public_path__ + "img/lrc.cb11a1c2.svg";